import { StatusEgressState as S } from '@tryiris-ai/common.protojs/agent/v1/agent';
import { logger } from '#~/logger/index.js';

type Fields = Record<string, string | number | boolean | undefined>;

// The N6 hook drops a stop silently when one of its gates fails, and HIL CI
// cannot reveal which gate it was. Each line names the deciding gate so the
// next intermittent miss is diagnosable from the job log alone.
// Per private-diagnostics-use-positive-allowlists (ai.knowledge/global): callers
// pass only device IDs, state names, booleans and counts. Never room IDs,
// camera names, file paths or raw egress error text.
export const traceRecordingSaved = (event: string, fields: Fields = {}): void => {
  try {
    logger.info(
      `[recording-saved-trace] ${JSON.stringify({ event, at: new Date().toISOString(), ...fields })}`
    );
  } catch {
    // Diagnostics must not change whether a saved recording is announced.
  }
};

/** Short egress state name for trace lines; `none` means no recording status. */
export const egressStateName = (state: S | undefined): string =>
  state === undefined ? 'none' : (S[state]?.replace('EGRESS_STATE_', '') ?? String(state));
